/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

import shapeImg1 from "../../assets/img/footer/shape-1-1.png";
import shapeImg2 from "../../assets/img/footer/shape-1-2.png";

const QUICK_LINKS = [
  { label: "About Us", to: "/about" },
  { label: "Departments", to: "/departments" },
  { label: "Our Doctors", to: "/our-doctors" },
  { label: "Research", to: "/research" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

const PATIENT_LINKS = [
  { label: "Book Appointment", to: "/appointment" },
  { label: "Patient Login", to: "/patient-login" },
  { label: "My Appointments", to: "/my-appointments" },
  { label: "My Reports", to: "/my-reports" },
  { label: "FAQs", to: "/faq" },
];

const Footer = (props) => {
  const { footerClass } = props;
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className={footerClass ? footerClass : "it-footer-area black-bg fix z-index p-relative pt-130 pb-70"}>
        <div className="it-footer-shape-1">
          <img src={shapeImg1} alt="" />
        </div>
        <div className="it-footer-shape-2 d-none d-xl-block">
          <img src={shapeImg2} alt="" />
        </div>
        <div className="container">
          <div className="row">
            {/* Brand */}
            <div
              className="col-xxl-4 col-xl-4 col-lg-5 col-md-6 col-sm-10 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="it-footer-widget footer-col-1">
                <div className="it-footer-logo">
                  <Link to="/">
                    <img src="/images/logo/logo-full.png" alt="Maroof International Hospital" style={{ maxWidth: 200 }} />
                  </Link>
                </div>
                <div className="it-footer-text pb-15">
                  <p>
                    Maroof International Hospital is a multi-disciplinary tertiary care hospital in F-10 Markaz, Islamabad — delivering
                    compassionate, world-class healthcare 24/7.
                  </p>
                </div>
                <div className="it-footer-widget-contact" style={{ marginTop: 18 }}>
                  <div className="d-flex align-items-center mb-10" style={{ color: "#fff" }}>
                    <i className="fa-solid fa-phone" style={{ marginRight: 10, color: "#04b3bf" }}></i>
                    <a className="hover-anim white" href="tel:+92511116449111">
                      +92-51-111-644-911
                    </a>
                  </div>
                  <div className="d-flex align-items-center mb-10" style={{ color: "#fff" }}>
                    <i className="fa-solid fa-envelope" style={{ marginRight: 10, color: "#04b3bf" }}></i>
                    <a className="hover-anim white" href="mailto:info@maroof.com.pk">
                      info@maroof.com.pk
                    </a>
                  </div>
                  <div className="d-flex align-items-start" style={{ color: "#fff" }}>
                    <i className="fa-solid fa-location-dot" style={{ marginRight: 10, marginTop: 5, color: "#04b3bf" }}></i>
                    <a
                      className="hover-anim white"
                      href="https://www.google.com/maps/search/?api=1&query=Maroof+International+Hospital+F-10+Markaz+Islamabad"
                      target="_blank"
                      rel="noreferrer"
                    >
                      F-10 Markaz, Islamabad, Pakistan
                    </a>
                  </div>
                </div>
                <div className="it-footer-social" style={{ marginTop: 22 }}>
                  <a href="https://www.facebook.com/MaroofInternationalHospital" target="_blank" rel="noreferrer" aria-label="Facebook">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/maroofinternationalhospital" target="_blank" rel="noreferrer" aria-label="Instagram">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a href="https://www.youtube.com/@MaroofInternationalHospital" target="_blank" rel="noreferrer" aria-label="YouTube">
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div
              className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <div className="it-footer-widget footer-col-2">
                <h4 className="it-footer-widget-title">Quick Links:</h4>
                <div className="it-footer-list">
                  <ul>
                    {QUICK_LINKS.map((l) => (
                      <li key={l.to}>
                        <Link to={l.to}>
                          <i className="fa-regular fa-angle-right"></i>
                          {l.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Patient Services */}
            <div
              className="col-xxl-3 col-xl-2 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <div className="it-footer-widget footer-col-3">
                <h4 className="it-footer-widget-title">Patient Services:</h4>
                <div className="it-footer-list">
                  <ul>
                    {PATIENT_LINKS.map((l) => (
                      <li key={l.to}>
                        <Link to={l.to}>
                          <i className="fa-regular fa-angle-right"></i>
                          {l.label}
                        </Link>
                      </li>
                    ))}
                    <li>
                      <a href="https://reports.maroof.com.pk" target="_blank" rel="noreferrer">
                        <i className="fa-regular fa-angle-right"></i>Online Reports
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Emergency Card */}
            <div
              className="col-xxl-3 col-xl-3 col-lg-12 col-md-12 col-sm-12 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".9s"
            >
              <div
                style={{
                  background: "linear-gradient(135deg,#dc2626 0%,#b91c1c 100%)",
                  borderRadius: 16,
                  padding: 24,
                  color: "#fff",
                  boxShadow: "0 12px 30px rgba(220,38,38,0.35)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                  <i className="fa-solid fa-truck-medical" style={{ fontSize: 28 }}></i>
                  <h4 style={{ margin: 0, fontSize: "1.15rem", fontWeight: 800, color: "#fff" }}>24/7 Emergency</h4>
                </div>
                <p style={{ margin: "0 0 14px", fontSize: "0.88rem", opacity: 0.95 }}>Round-the-clock emergency, ambulance & critical care.</p>
                <a
                  href="tel:+92511116449111"
                  style={{
                    display: "inline-block",
                    background: "#fff",
                    color: "#b91c1c",
                    fontWeight: 800,
                    padding: "10px 18px",
                    borderRadius: 999,
                    textDecoration: "none",
                    fontSize: "0.95rem",
                  }}
                >
                  <i className="fa-solid fa-phone" style={{ marginRight: 8 }}></i>
                  111-644-911
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-copyright-area it-copyright-height">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".3s">
              <div className="it-copyright-text text-center text-md-start">
                <p>
                  Copyright © {currentYear} <Link to="/">Maroof International Hospital</Link> · All Rights Reserved
                </p>
              </div>
            </div>
            <div className="col-md-6 wow animate__fadeInUp" data-wow-duration=".9s" data-wow-delay=".5s">
              <div className="it-copyright-text text-center text-md-end" style={{ fontSize: "0.85rem", opacity: 0.75 }}>
                <Link to="/contact" style={{ marginRight: 14 }}>
                  Contact
                </Link>
                <Link to="/faq" style={{ marginRight: 14 }}>
                  FAQs
                </Link>
                <Link to="/research">Research</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
